module.exports = __webpack_public_path__ + "img/FRS_LOGO_SHADOWED.e4130449.png";